module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-container-single element-non-bodymatter element-type-copyright element-without-heading",
    attrs: {
      "epub:type": "copyright-page",
      "id": "copyright"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "copyright-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_c('b', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Brother Blood, Sister Death")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Copyright © 2020 Bill Ransom")])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width copyright-content"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any electronic or mechanical means, including photocopying, recording or by any information storage and retrieval system, without the express written permission of the copyright holder, except where permitted by law. This novel is a work of fiction. Names, characters, places and incidents are either the product of the author’s imagination, or, if real, used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("The ebook edition of this book is licensed for your personal enjoyment only. The ebook may not be re-sold or given away to other people. If you would like to share the ebook edition with another person, please purchase an additional copy for each recipient. Thank you for respecting the hard work of this author.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("EBook ISBN: 978-1-68057-017-5")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Trade Paperback ISBN: 978-1-68057-019-9")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Hardcover ISBN: 978-1-68057-016-8")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Cover design by Janet McDonald")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Cover artwork images by Adobe Image")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Kevin J. Anderson, Art Director")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Published by")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("WordFire Press, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("PO Box 1840")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Monument CO 80132")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Kevin J. Anderson & Rebecca Moesta, Publishers")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("WordFire Press eBook Edition 2020")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("WordFire Press Trade Paperback Edition 2020")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("WordFire Press Hardcover Edition 2020")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Printed in the USA")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Join our WordFire Press Readers Group for")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("sneak previews, updates, new projects, and giveaways.")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Sign up at "), _c('a', {
    staticClass: "content-external-link text-is-url",
    attrs: {
      "href": "http://wordfirepress.com",
      "target": "_blank"
    }
  }, [_vm._v("wordfirepress.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "created-with-vellum"
  }, [_c('a', {
    attrs: {
      "href": "http://tryvellum.com/created",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "created-with-vellum-image-decorator"
  }, [_c('span', {
    staticClass: "created-with-vellum-image-size-container"
  }, [_c('img', {
    staticClass: "created-with-vellum-image",
    attrs: {
      "alt": "Created with Vellum",
      "src": "images/vellum-created.svg"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "created-with-vellum-text"
  }, [_vm._v("Created with Vellum")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8673887c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 69
// module chunks = 0